import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import { useCustomersContext } from "../../../../../context/CustomersContext";

export default function DeleteLocal({ customerId, show, setShow, local, locals, updateLocals }) {
  const { deleteCustomerLocal } = useCustomersContext();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const handleClose = () => {
    if (loading) return;
    setError(false);
    setShow(false);
  };

  const handleDelete = async () => {
    if (!local?._id) return;
    setLoading(true);
    const success = await deleteCustomerLocal({ customerID: customerId, localID: local._id });
    setLoading(false);

    if (!success) {
      setError(true);
      return;
    }

    const newLocals = locals.filter((l) => l._id !== local._id);
    updateLocals(newLocals);
    setShow(false);
  };

  return (
    <Dialog open={show} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogContent style={{ textAlign: "center", padding: "32px 24px" }}>
        <WarningIcon style={{ fontSize: 48, color: "#f44336" }} />
        <h4>¿Eliminar local?</h4>
        <Typography variant="body2">
          Esta acción eliminará el local{" "}
          <strong>{local?.name}</strong> de forma permanente. No se puede deshacer.
        </Typography>
        {error && (
          <Typography variant="body2" style={{ color: "#f44336", marginTop: 12 }}>
            Ocurrió un error al eliminar el local. Intenta nuevamente.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleDelete}
          color="secondary"
          variant="contained"
          disabled={loading}
        >
          {loading ? "Eliminando..." : "Eliminar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}